import type { Database } from "@excel-center/supabase";
import { z } from "zod";

type DBAllergySeverity = Database["public"]["Enums"]["allergy_severity"];

export const AllergySeverity = {
	MILD: "mild",
	MODERATE: "moderate",
	SEVERE: "severe",
} as const satisfies Record<string, DBAllergySeverity>;

export type AllergySeverity = (typeof AllergySeverity)[keyof typeof AllergySeverity];

type _EnsureAllDBValues = Exclude<DBAllergySeverity, AllergySeverity> extends never ? true : never;
const _check: _EnsureAllDBValues = true;
void _check;

export const ALLERGY_SEVERITIES = Object.values(AllergySeverity) as readonly AllergySeverity[];

export const allergySeveritySchema = z.enum(AllergySeverity);

export const ALLERGY_SEVERITY_LABELS: Record<AllergySeverity, string> = {
	mild: "Mild",
	moderate: "Moderate",
	severe: "Severe",
};
